module.exports = __webpack_public_path__ + "img/asia05.b6713d98.png";